const CloudDirectoryFilters = {
  isNew: bool => ({
    name: 'isNew',
    operator: 'eq',
    value: bool,
    type: 'status',
    displayValue: 'new',
  }),
};

export default CloudDirectoryFilters;
